<template>
	<div id="Expertthinkatnk" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/zjzk.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/zjzk_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>专家</span><span style="color:#D7230C;">智库</span></div>
					<div class="sm_pub">有困难找我们</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/Expertthinktankdetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<el-carousel indicator-position="outside" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;" :interval="5000" arrow="none">
			<el-carousel-item v-for="(item,index) in 1" :key="index">
				<div class="z_warp">
					<router-link tag="div" :to="{ path:'/zjzkdetail',query:{id:o.id,title:o.title} }" class="lb_cont" style="height: 290px;box-shadow: rgb(0 0 0 / 16%) 0px 4px 24px;"
						v-for="(o,index) in xptjlist[index]" :key="index">
						<div class="list_lb_img">
							<img v-lazy="o.picture" alt="">
						</div>
						<div class="xp_title" style="text-align: center;">
							{{o.title}}&nbsp;&nbsp;{{o.position}}
						</div>
						<!-- <div tag="div" class="ckxq_xp"
							>
							查看详情
						</div> -->
					</router-link>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: ''
			}
		},
		methods: {

		},
		async mounted() {
			let res = await http.post('api/Common/index', {
				model: 'expert',
				type: 'content',
				mid: '6',
				rows_limit: '5'
			})
			let xpList = res.data.data.list.data
			let newArr = [
				[],
				[],
			]
			xpList.forEach((item, index) => {
				if (index < 4) {
					newArr[0].push(item)
				} else if (index >= 4 && index < 8) {
					newArr[1].push(item)
				} else if (index >= 8 && index < 12) {
					newArr[2].push(item)
				}
			})
			this.xptjlist = newArr
		}
	}
</script>

<style scoped>
	#Expertthinkatnk {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 头部 */
	#Expertthinkatnk .pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	#Expertthinkatnk .pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .img_logo>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	#Expertthinkatnk .title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	#Expertthinkatnk .imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	#Expertthinkatnk .imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	#Expertthinkatnk .sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	#Expertthinkatnk .ct_title {
		float: left;

	}

	#Expertthinkatnk .ct_img {
		float: left;
		margin-left: 10px;
	}

	#Expertthinkatnk .ct_img>img {
		width: 12px;
		height: 10px;
	}

	#Expertthinkatnk .ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */

	#Expertthinkatnk .z_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	#Expertthinkatnk .lb_cont {
		float: left;
		width: calc((100% - 120px)/4);
		margin-left: 24px;
		height: 290px;
		border: 1px solid #ececec;
	}

	#Expertthinkatnk .list_lb_img {
		height: 250px;
	}

	#Expertthinkatnk .list_lb_img>img {
		width: 100%;
		height: 100%;
	}

	#Expertthinkatnk .xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	#Expertthinkatnk .ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}

	#Expertthinkatnk /deep/.el-carousel__container {
		height: 310px;
		margin-top: 20px;
	}
</style>
